import axios from "axios";

export const sendEmailApi = async (url, data) => {
  const res = await axios
    .post(url, data)
    .then((response) => response)
    .catch((error) => error.response);
  return res.data;
};
